module.exports = __webpack_public_path__ + "static/media/05.c74ee4ab.png";